import dayjs from 'dayjs';

export default function toISOString(date) {
    return dayjs(date).format('YYYY-MM-DDTHH:mm:ssZ');
}
